import type { Print } from '../../types/Print';

export const printBaseFeatureConfig: Print = {
    checkboxes: {
        showDefaultPerformance: false,
        showDefaultPurchasePrice: false,
    },
    columns: {
        hideCapitalGainTax: false,
        hideTotalProfitAndFee: false,
    },
    infoCheckBoxes: false,
    showAccountInfo: false,
    showInfoFilter: false,
    showSettlementAccount: false,
};
